import { render, staticRenderFns } from "./LegendTitle.vue?vue&type=template&id=2a5261b0&scoped=true&"
import script from "./LegendTitle.vue?vue&type=script&lang=ts&"
export * from "./LegendTitle.vue?vue&type=script&lang=ts&"
import style0 from "./LegendTitle.vue?vue&type=style&index=0&id=2a5261b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5261b0",
  null
  
)

export default component.exports